export default __webpack_public_path__ + "static/media/Empowering Atlantean Catalyst.33f20a01.jpg";